<template>
    <SummaryGuest
        v-if="!userName"
        :summary-groups="summaryGroups"
        :monthly-price="monthlyPrice"
        :setup-price="setupPrice"
    />
    <SummaryUser
        v-else
        :user-name="userName"
        :summary-groups="summaryGroups"
        :type="type"
        :monthly-price="monthlyPrice"
        :setup-price="setupPrice"
        :mail-summary="mailSummary"
        :selection="selection"
        :redirect-params="redirectParams"
    />
</template>

<script setup>
defineOptions({ name: 'FeConfiguratorSummary' });
import { defineProps } from 'vue';
import SummaryGuest from './SummaryGuest.vue';
import SummaryUser from './SummaryUser.vue';

defineProps({
    summaryGroups: { type: Array, default: () => [] },
    type: { type: String, required: true },
    monthlyPrice: { type: Number, required: true },
    setupPrice: { type: Number, required: true },
    mailSummary: { type: Object, required: true },
    selection: { type: Object, required: true },
    redirectParams: { type: String, default: '' },
});

const userName = document.querySelector('meta[name="user"]').getAttribute('content') || '';
</script>
